import { OfferingSelectionOperator } from '@/models'
import { OfferingSelectionState } from '@/store/new-connection-cmh/offerings-selection/types'
import { MutationTree } from 'vuex'

export enum MutationType {
  MUTATION_STORE = 'STORE',
  MUTATION_ADD_OPERATOR = 'ADD_OPERATOR',
  MUTATION_ADD_MANY_OPERATOR = 'ADD_MANY_OPERATOR',
  MUTATION_REMOVE_OPERATOR = 'REMOVE_OPERATOR',
  MUTATION_REMOVE_ANY_OPERATOR = 'REMOVE_ANY_OPERATOR',
  MUTATION_CLEAR = 'CLEAR',
}

export const mutations: MutationTree<OfferingSelectionState> = {
  [MutationType.MUTATION_STORE](state, data: OfferingSelectionOperator[]) {
    state.selections = data
  },
  [MutationType.MUTATION_ADD_OPERATOR](state, operator: OfferingSelectionOperator) {
    if (!state.selections.find(s => s === operator)) {
      state.selections.push(operator)
    }
  },
  [MutationType.MUTATION_ADD_MANY_OPERATOR](state, operators: OfferingSelectionOperator[]) {
    if (!state.selections.find(s => operators.includes(s))) {
      state.selections.push(...operators)
    }
  },
  [MutationType.MUTATION_REMOVE_OPERATOR](state, operator: OfferingSelectionOperator) {
    state.selections = state.selections.filter(s => s !== operator)
  },
  [MutationType.MUTATION_REMOVE_ANY_OPERATOR](state, operators: OfferingSelectionOperator[]) {
    state.selections = state.selections.filter(s => !operators.includes(s))
  },
  [MutationType.MUTATION_CLEAR](state) {
    state.selections = []
  }
}
